import React, { FC, useEffect, useState } from "react";
import { Input, Button, Row, Col, Radio, Select, Collapse } from "antd";
import { SearchOutlined, DownOutlined, CloseOutlined } from "@ant-design/icons";
import _ from "lodash";
import Icon from "@ant-design/icons";
import { Marker } from "react-google-maps";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { ReactSVG } from "react-svg";
import { SocketTopics, UserTopics } from "../../../constants/enums";
import { wrapRequestPayload } from "../../../helpers/request/RequestPayload";
import {formatForRedis, formatUserFilterText} from "utils/appUtil";
import { FilterOption } from "utils/PageTypes";


const pageSearchStringGenerator = (search: string) => {
  const searchSplit = search.split(" ");
  if (searchSplit.length === 1)
    return `(@title:(${formatForRedis(searchSplit[0])}*))`;
  else {
    let lastWord = searchSplit.pop();
    return `@title:(${searchSplit.join("&")}${
      lastWord !== "" ? `&%${lastWord}%` : ""
    })`;
  }
};

const { Option } = Select;
const { Panel } = Collapse;
const defaultPagination = 50;
let timeout: NodeJS.Timeout;


const filterMap: FilterMap = {
  place: "SET_PLACES",
  asset: "SET_ASSETS",
  user: "SET_PEOPLES",
  media: "SET_MEDIAS",
  page: "SET_PAGES",
  gps: "SET_GPSS",
  event: "SET_EVENTS",
};

const FilterPop: FC<{
  setActivePop: (activePop: string) => void;
  mapType: string;
  socket: ISocket;
}> = ({ setActivePop, mapType, socket }) => {
  const dispatch = useDispatch();
  const { selectedItem } = useSelector((state: RootState) => state.search);
  const { lastLocation, userBds } = useSelector(
    (state: RootState) => state.auth
  );
  const { projects, adminRoles, mapBounds } = useSelector(
    (state: RootState) => state.dashboard
  );
  const {
    map_places_filter,
    map_assets_filter,
    map_peoples_filter,
    map_pages_filter,
    map_medias_filter,
    map_gpss_filter,
    map_events_filter,
    places,
    assets,
    medias,
    pages,
    peoples,
    gpss,
    events,
    selected_places,
    location_profiles,
    selectedFilter,
    enabledFilter,
  } = useSelector((state: RootState) => state.dashboard);
  const [selectedPlacesIds, setSelectedPlacesIds] = useState<string[]>([]);
  const [selectedAssetsIds, setSelectedAssetsIds] = useState<string[]>([]);
  const [selectedPeoplesIds, setSelectedPeoplesIds] = useState<string[]>([]);
  const [selectedPagesIds, setSelectedPagesIds] = useState<string[]>([]);
  const [selectedMediaIds, setSelectedMediasIds] = useState<string[]>([]);
  const [selectedGpsIds, setSelectedGpsIds] = useState<string[]>([]);
  const [selectedEventIds, setSelectedEventIds] = useState<string[]>([]);
  const [dropdownVisible, setDropdownVisible] = useState<boolean>(false);

  const [tempSelectedPlaces, setTempSelectedPlaces] = useState<any>();
  const setLocations = (type: any, places: object) => {
    dispatch({ type: filterMap[type], payload: places });
  };

  const setSelectedLocations = (places: object[]) => {
    dispatch({
      type: "SET_SELECTED_PLACES",
      payload: { items: places, fitBounds: true },
    });
  };

  const onGroup = () => {
  };

  const getPageFilterLocations = (type?: any, callback?:any) => {
    const requestData = {
      objectType: type,
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:messageOriginalCreatedAtIndex`,
          searchQuery: `@pageId:{${selectedItem.pageId}}@type:{${type}}`,
          searchOptions: "VERBATIM TIMEOUT 10000",
        },
        load: { object: "$" },
      },
      groupBy: {
        properties: ["@originalCreatedAt"],
        reducers: [{ func: "TOLIST", arguments: ["@object"], name: "objects" }],
      },
      sortBy: {
        properties: [{ field: "@originalCreatedAt", order: "DESC" }],
        max: 10000,
      },
      result: { pagination: { offset: 0, limit: 10000 } },
      filter: { expression: "" },
    };
    dispatch({
      type: "GET_PAGE_PLACES_FILTER",
      payload: {requestData, callback},
    });
    setLocations(type, {
      searching: true,
      page: 0,
      pagination: false,
    });
  };

  const getFilterLocations = (
    type?: any,
    search?: string,
    page: number = 0,
    pagination: boolean = true,
    profiles?: { id?: string }[]
  ) => {
    let requestData;
    if (type === FilterOption.USER) {

      requestData = {
        objectType: type,
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
            searchQuery: `@serviceId:{'${formatForRedis(
              projects?.userServiceId
            )}'}${search ? formatUserFilterText(search) : ""}`,
            searchOptions: "TIMEOUT 1000",
          },
          load: {
            email: "$..live.alternativeIds.email",
            phone: "$..live.alternativeIds.phone",
            profile: "$..profile",
            latitude: "$..profile.location.coordinates.lat",
            longitude: "$..profile.location.coordinates.long",
          },
        },
        groupBy: {
          properties: [
            "@email",
            "@profile",
            "@phone",
            "@latitude",
            "@longitude",
          ],
          reducers: [
            {
              func: "TOLIST",
              arguments: ["@objectId"],
              name: "objectIds",
            },
          ],
        },
        apply: {
          expression: "",
          name: "",
        },
        filter: {
          expression: "@latitude > 0 && @longitude > 0",
        },
        result: {
          pagination: {
            offset: page * defaultPagination,
            limit: defaultPagination,
          },
        },
        anyStatus: false,
      };
    }

    if (type === FilterOption.GPS) {
      const responderRoles = adminRoles
        .filter((x) => {
          return x.permissions.indexOf("onMove") !== -1;
        })
        .map((y) => {
          return `@roleId === '${y._id}'`;
        });
      requestData = {
        objectType: type,
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
            searchQuery: `@serviceId:{'${formatForRedis(
              projects?.userServiceId
            )}'}${search ? formatUserFilterText(search) : ""}`,
            searchOptions: "TIMEOUT 1000",
          },
          load: {
            email: "$..live.alternativeIds.email",
            phone: "$..live.alternativeIds.phone",
            profile: "$..profile",
            roleId: "$..admin.profile.roleId",
            beamIds: "$..beamIds"
          },
        },
        groupBy: {
          properties: ["@email", "@phone", "@profile", "@roleId", "@beamIds"],
          reducers: [
            {
              func: "TOLIST",
              arguments: ["@objectId"],
              name: "objectIds",
            },
          ],
        },
        apply: {
          expression: "",
          name: "",
        },
        result: {
          pagination: {
            offset: page * defaultPagination,
            limit: defaultPagination,
          },
        },
        filter: {
          expression: `exists(@roleId) && (${responderRoles.join("||")})`,
        },
        anyStatus: false,
      };
    }

    if (type === FilterOption.PAGE) {
      requestData = {
        objectType: type,
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:pageTitleIndex`,
            searchQuery: `@pageType:{'event'}@pageMembers:{'${localStorage.getItem(
              "RID"
            )}'}${search ? pageSearchStringGenerator(search) : ""}`,
            searchOptions: "TIMEOUT 1000",
          },
          load: {
            persistent: "$.persistent",
            latitude: "$.persistent.static.live.location.coordinates.lat",
            longitude: "$.persistent.static.live.location.coordinates.long",
          },
        },
        groupBy: {
          properties: ["@persistent", "@latitude", "@longitude"],
          reducers: [
            {
              func: "TOLIST",
              arguments: ["@objectId"],
              name: "objectIds",
            },
          ],
        },
        apply: {
          expression: "",
          name: "",
        },
        result: {
          pagination: {
            offset: page * defaultPagination,
            limit: defaultPagination,
          },
        },
        filter: {
          expression: "@latitude > 0 && @longitude > 0",
        },
        anyStatus: false,
      };
    }

    if (type === FilterOption.PLACE) {
      requestData = {
        objectType: type,
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
            searchQuery: `@userType:{'poi'}@serviceId:{'${formatForRedis(
              projects?.userServiceId
            )}'}`,
            searchOptions: "TIMEOUT 1000",
          },
          load: {
            persistent: "$.persistent",
            latitude: "$.persistent.static.poi.location.coordinates.lat",
            longitude: "$.persistent.static.poi.location.coordinates.long",
          },
        },
        groupBy: {
          properties: ["@persistent", "@latitude", "@longitude"],
          reducers: [
            {
              func: "TOLIST",
              arguments: ["@objectId"],
              name: "objectIds",
            },
          ],
        },
        apply: {
          expression: "",
          name: "",
        },
        result: {
          pagination: {
            offset: page * defaultPagination,
            limit: defaultPagination,
          },
        },
        filter: {
          expression: "@latitude > 0 && @longitude > 0",
        },
        anyStatus: false,
      };
    }

    if (type === FilterOption.ASSET) {
      requestData = {
        objectType: type,
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
            searchQuery: `@userType:{'fixedAsset'}@serviceId:{'${formatForRedis(
              projects?.userServiceId
            )}'}`,
            searchOptions: "TIMEOUT 1000",
          },
          load: {
            persistent: "$.persistent",
            latitude: "$.persistent.static.asset.location.coordinates.lat",
            longitude: "$.persistent.static.asset.location.coordinates.long",
          },
        },
        groupBy: {
          properties: ["@persistent", "@latitude", "@longitude"],
          reducers: [
            {
              func: "TOLIST",
              arguments: ["@objectId"],
              name: "objectIds",
            },
          ],
        },
        apply: {
          expression: "",
          name: "",
        },
        result: {
          pagination: {
            offset: page * defaultPagination,
            limit: defaultPagination,
          },
        },
        filter: {
          expression: "@latitude > 0 && @longitude > 0",
        },
        anyStatus: false,
      };
    }

    if (type === FilterOption.MEDIA) {
      requestData = {
        objectType: type,
        paths: ["$"],
        returnPaths: ["$"],
        anyStatus: false,
        pagination: {
          offset: page * defaultPagination,
          limit: defaultPagination,
        },
      };
    }

    if (type === FilterOption.EVENT) {
      requestData = {
        objectType: type,
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:messageStorageIndex`,
            searchQuery: "@type:{event}",
            searchOptions: "TIMEOUT 1000",
          },
          list: {},
          load: {
            message: "$.message",
            pageInfo: "$.pageInfo",
            latitude: "$.message.attributes.location.coordinates.lat",
            longitude: "$.message.attributes.location.coordinates.long",
          },
        },
        groupBy: {
          properties: ["@message", "@pageInfo", "@latitude", "@longitude"],
          reducers: [
            {
              func: "TOLIST",
              arguments: ["@objectId"],
              name: "objectIds",
            },
          ],
        },
        apply: {
          expression: "",
          name: "",
        },
        result: {},
        filter: {
          expression: "@latitude > 0 && @longitude > 0",
        },
        anyStatus: false,
        pagination: {
          offset: page * defaultPagination,
          limit: defaultPagination,
        },
      };
    }

    dispatch({
      type: "GET_MAP_PLACES_FILTER",
      payload: requestData,
    });
    setLocations(type, {
      searching: true,
      page,
      pagination,
    });
  };

  const onFilterChange = (
    type: any,
    filteredLocations: PlaceItem[],
    allLocations: any
  ) => {
    let selectedPlaces = selected_places.items;
    selected_places.items.map((place, idx) => {
      filteredLocations.some((filteredlocation) => {
        if (filteredlocation.id === place.id) {
          selectedPlaces[idx].name = filteredlocation.name;
          return true;
        }
      });
    });
    let tempPlaces = [...selectedPlaces, ...filteredLocations];
    tempPlaces = tempPlaces.filter(
      (value, index, self) =>
        index === self.findIndex((t) => t.id === value.id) &&
        value.objectType === type
    );
    setLocations(type, {
      items:
        allLocations.page === 0
          ? tempPlaces
          : [...allLocations.items, ...filteredLocations],
      searching: false,
      pagination: filteredLocations.length > 0,
    });
  };

  useEffect(() => {
    if (map_places_filter) {
      onFilterChange(FilterOption.PLACE, map_places_filter, places);
    }
  }, [map_places_filter]);

  useEffect(() => {
    if (map_assets_filter) {
      onFilterChange(FilterOption.ASSET, map_assets_filter, assets);
    }
  }, [map_assets_filter]);

  useEffect(() => {
    if (map_peoples_filter) {
      onFilterChange(FilterOption.USER, map_peoples_filter, peoples);
    }
  }, [map_peoples_filter]);

  useEffect(() => {
    if (map_pages_filter) {
      onFilterChange(FilterOption.PAGE, map_pages_filter, pages);
    }
  }, [map_pages_filter]);

  useEffect(() => {
    if (map_medias_filter) {
      onFilterChange(FilterOption.MEDIA, map_medias_filter, medias);
    }
  }, [map_medias_filter]);

  useEffect(() => {
    if (map_gpss_filter) {
      onFilterChange(FilterOption.GPS, map_gpss_filter, gpss);
    }
  }, [map_gpss_filter]);

  useEffect(() => {
    if (map_events_filter) {
      onFilterChange(FilterOption.EVENT, map_events_filter, events);
    }
  }, [map_events_filter]);

  useEffect(() => {
    if (selected_places) {
      let filteredPlaces = selected_places.items.filter((e) => {
        return e.objectType === FilterOption.PLACE;
      });
      let filteredAssets = selected_places.items.filter((e) => {
        return e.objectType === FilterOption.ASSET;
      });
      let filteredPeoples = selected_places.items.filter((e) => {
        return e.objectType === FilterOption.USER;
      });
      let filteredPages = selected_places.items.filter((e) => {
        return e.objectType === FilterOption.PAGE;
      });
      let filteredMedias = selected_places.items.filter((e) => {
        return e.objectType === FilterOption.MEDIA || e.objectType === "medium";
      });
      let filteredGpss = selected_places.items.filter((e) => {
        return e.objectType === FilterOption.GPS;
      });
      let filteredEvents = selected_places.items.filter((e) => {
        return e.objectType === FilterOption.EVENT;
      });
      setSelectedPlacesIds(
        filteredPlaces.map((e) => {
          return e.id || "";
        })
      );
      setSelectedGpsIds(
        filteredGpss.map((e) => {
          return e.id || "";
        })
      );
      setSelectedEventIds(
        filteredEvents.map((e) => {
          return e.id || "";
        })
      );
      setSelectedAssetsIds(
        filteredAssets.map((e) => {
          return e.id || "";
        })
      );
      setSelectedPagesIds(
        filteredPages.map((e) => {
          return e.id || "";
        })
      );
      setSelectedPeoplesIds(
        filteredPeoples.map((e) => {
          return e.id || "";
        })
      );
      setSelectedMediasIds(
        filteredMedias.map((e) => {
          return e.id || "";
        })
      );
    }
  }, [selected_places]);

  const resetLocations = (type: any) => {
    if (mapType == "PAGE") {
      getPageFilterLocations(type);
      return;
    }
    getFilterLocations(type);
  };

  const onAll = (type: string) => {
    if (!tempSelectedPlaces) return;

    setSelectedLocations(tempSelectedPlaces);

    if (type === FilterOption.GPS) {
      let filteredGps = tempSelectedPlaces.filter((e: any) => {
        return e.objectType === FilterOption.GPS;
      });

      Object.keys(lastLocation).map((y) => {
        console.log("un subscribe to ", lastLocation[y].imei);
        socket.unSubscribeToEvent(
          SocketTopics.SubscribePageTopics,
          lastLocation[y].imei
        );
      });

      filteredGps.map((user) => {
        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          `${
            process.env.REACT_APP_ECO_SYSTEM
          }/connection/${localStorage.getItem(
            "CID"
          )}/service/iot-service/getLastIndex`,
          wrapRequestPayload(
            {
              filter: `ecosystem=${process.env.REACT_APP_ECO_SYSTEM} userId=${user.id} channelName=locationGps`,
              options: {
                latest: false,
              },
            },
            user.id
          )
        );
      });
    }

    setTempSelectedPlaces(undefined);
  };

  const onClear = (type: string) => {
    let places = [...selected_places?.items!];
    places = places.filter((e) => {
      return e.objectType !== type;
    });
    setSelectedLocations(places);
  };

  const onFilterClick = (type) => {
    switch (type) {
      case FilterOption.USER:
        let filteredPeoples = selected_places.items.filter((e: any) => {
          return e.objectType === FilterOption.USER;
        });
        setSelectedPeoplesIds(
          filteredPeoples.map((e: any) => {
            return e.id || "";
          })
        );
        break;
      case FilterOption.PAGE:
        let filteredPages = selected_places.items.filter((e: any) => {
          return e.objectType === FilterOption.PAGE;
        });
        setSelectedPagesIds(
          filteredPages.map((e: any) => {
            return e.id || "";
          })
        );
        break;
      case FilterOption.PLACE:
        let filteredPlaces = selected_places.items.filter((e: any) => {
          return e.objectType === FilterOption.PLACE;
        });
        setSelectedPlacesIds(
          filteredPlaces.map((e: any) => {
            return e.id || "";
          })
        );
        break;
      case FilterOption.ASSET:
        let filteredAssets = selected_places.items.filter((e: any) => {
          return e.objectType === FilterOption.ASSET;
        });
        setSelectedAssetsIds(
          filteredAssets.map((e: any) => {
            return e.id || "";
          })
        );
        break;
      case FilterOption.GPS:
        let filteredGps = selected_places.items.filter((e: any) => {
          return e.objectType === FilterOption.GPS;
        });
        setSelectedGpsIds(
          filteredGps.map((e: any) => {
            return e.id || "";
          })
        );
        break;
      case FilterOption.MEDIA:
        let filteredMedia = selected_places.items.filter((e: any) => {
          return (
            e.objectType === FilterOption.MEDIA || e.objectType === "medium"
          );
        });
        setSelectedMediasIds(
          filteredMedia.map((e: any) => {
            return e.id || "";
          })
        );
        break;
      case FilterOption.EVENT:
        let filteredEvent = selected_places.items.filter((e: any) => {
          return e.objectType === FilterOption.EVENT;
        });
        setSelectedEventIds(
          filteredEvent.map((e: any) => {
            return e.id || "";
          })
        );
        break;
    }

    const existInsideBox = (p, bb) => {
      if (bb.ix <= p.x && p.x <= bb.ax && bb.iy <= p.y && p.y <= bb.ay) {
        return true;
      } else return false;
    };

    setTempSelectedPlaces(undefined);
    
    if (selectedFilter !== type) {
      dispatch({
        type: "SET_SELECTED_FILTER",
        payload: type,
      });
      if (enabledFilter.indexOf(type) === -1) {

        if (mapType == "PAGE") {
          getPageFilterLocations(type, (data)=>{

            const boundLocations = data.filter((marker) => {
              const existInside = existInsideBox(
                { x: marker?.location?.coordinates?.[1], y: marker?.location?.coordinates?.[0] },
                {
                  ix: mapBounds.bounds.minLat,
                  iy: mapBounds.bounds.minLon,
                  ax: mapBounds.bounds.maxLat,
                  ay: mapBounds.bounds.maxLon,
                }
              );
              return existInside
            });

            let tempPlaces: object[] = [...selected_places.items, ...boundLocations];
            setSelectedLocations(tempPlaces);
          });
        }


        dispatch({
          type: "SET_ENABLED_FILTER",
          payload: [...enabledFilter, type],
        });
      }
    } else {
      dispatch({
        type: "SET_SELECTED_FILTER",
        payload: undefined,
      });
      const index = enabledFilter.indexOf(type);
      if (index !== -1) {
        dispatch({
          type: "SET_ENABLED_FILTER",
          payload: enabledFilter.filter((x) => {
            return x !== type;
          }),
        });
        onClear(type);

      }
    }
  };

  return (
    <div className="pop-content filter-popup bg-white">
      <Row className="d-flex mb-4">
        <Col>
          <h3>Filters</h3>
        </Col>
        <Col>
          <CloseOutlined
            className="close-icon"
            onClick={() => setActivePop("")}
          />
        </Col>
      </Row>

      <div className="d-flex justify-content-space-between mb-4">
        <div className="map-filter-btn">
          <Button
            className="beam-btn"
            onClick={() => {
              onFilterClick("user");
            }}
          >
            <ReactSVG
              src="/images/map-filter-1.svg"
              className={`add-icon ${
                selectedFilter === "user" ||
                enabledFilter.indexOf("user") !== -1
                  ? "selected"
                  : ""
              }`}
            />
          </Button>
          <p>User</p>
        </div>

        {mapType == "HOME" && (
          <div className="map-filter-btn ml-2">
            <Button
              className="beam-btn"
              onClick={() => {
                onFilterClick("page");
              }}
            >
              <ReactSVG
                src="/images/map-filter-2.svg"
                className={`add-icon ${
                  selectedFilter === "page" ||
                  enabledFilter.indexOf("page") !== -1
                    ? "selected"
                    : ""
                }`}
              />
            </Button>
            <p>Page</p>
          </div>
        )}

        <div className="map-filter-btn ml-2">
          <Button
            className="beam-btn"
            onClick={() => {
              onFilterClick(FilterOption.MEDIA);
            }}
          >
            <ReactSVG
              src="/images/map-filter-3.svg"
              className={`add-icon ${
                selectedFilter === FilterOption.MEDIA ||
                enabledFilter.indexOf(FilterOption.MEDIA) !== -1
                  ? "selected"
                  : ""
              }`}
            />
          </Button>
          <p>Media</p>
        </div>

        <div className="map-filter-btn ml-2">
          <Button
            className="beam-btn"
            onClick={() => {
              onFilterClick(FilterOption.PLACE);
            }}
          >
            <ReactSVG
              src="/images/map-filter-5.svg"
              className={`add-icon ${
                selectedFilter === FilterOption.PLACE ||
                enabledFilter.indexOf(FilterOption.PLACE) !== -1
                  ? "selected"
                  : ""
              }`}
            />
          </Button>
          <p>Place</p>
        </div>

        {mapType == "HOME" && (
          <div className="map-filter-btn ml-2">
            <Button
              className="beam-btn"
              onClick={() => {
                onFilterClick(FilterOption.GPS);
              }}
            >
              <ReactSVG
                src="/images/map-filter-4.svg"
                className={`add-icon ${
                  selectedFilter === FilterOption.GPS ||
                  enabledFilter.indexOf(FilterOption.GPS) !== -1
                    ? "selected"
                    : ""
                }`}
              />
            </Button>
            <p>GPS</p>
          </div>
        )}

        <div className="map-filter-btn ml-2">
          <Button
            className="beam-btn"
            onClick={() => {
              onFilterClick(FilterOption.EVENT);
            }}
          >
            <ReactSVG
              src="/images/map-filter-6.svg"
              className={`add-icon ${
                selectedFilter === FilterOption.EVENT ||
                enabledFilter.indexOf(FilterOption.EVENT) !== -1
                  ? "selected"
                  : ""
              }`}
            />
          </Button>
          <p>Event</p>
        </div>

        <div className="map-filter-btn ml-2">
          <Button
            className="beam-btn"
            onClick={() => {
              onFilterClick(FilterOption.ASSET);
            }}
          >
            <ReactSVG
              src="/images/map-filter-5.svg"
              className={`add-icon ${
                selectedFilter === FilterOption.ASSET ||
                enabledFilter.indexOf(FilterOption.ASSET) !== -1
                  ? "selected"
                  : ""
              }`}
            />
          </Button>
          <p>Asset</p>
        </div>
      </div>

      {selectedFilter === FilterOption.USER && (
        <React.Fragment>
          <Collapse defaultActiveKey={["1"]} bordered={false}>
            <Panel
              header={
                <Row>
                  <Col span={24}>
                    <p className="mb-1" style={{ color: "#000000" }}>
                      Peoples
                    </p>
                  </Col>
                </Row>
              }
              key="1"
            >
              <Select
                mode="multiple"
                placeholder="Please select peoples"
                onDropdownVisibleChange={(visible) => {
                  if (visible) {
                    setDropdownVisible(true);
                  } else {
                    setTimeout(() => {
                      setDropdownVisible(false);
                    }, 300);
                  }
                }}
                allowClear={true}
                dropdownStyle={{ height: 150 }}
                onChange={(values: string[]) => {console.log(peoples)
                  let tempPlaces: object[] = peoples.items.filter((e) => {
                    return values.indexOf(e.id) !== -1;
                  });
                  tempPlaces = [...selected_places.items, ...tempPlaces];
                  tempPlaces = tempPlaces.filter(
                    (value: any, index, self) =>
                      index === self.findIndex((t: any) => t.id === value.id) &&
                      (values.indexOf(value.id) !== -1 ||
                        value.objectType !== FilterOption.USER)
                  );
                  setTempSelectedPlaces(tempPlaces);

                  let filteredPeoples = tempPlaces.filter((e: any) => {
                    return e.objectType === FilterOption.USER;
                  });

                  setSelectedPeoplesIds(
                    filteredPeoples.map((e: any) => {
                      return e.id || "";
                    })
                  );
                }}
                value={selectedPeoplesIds}
                loading={peoples.searching}
                maxTagCount={0}
                style={{ width: "100%" }}
                listHeight={150}
                onFocus={() => {
                  if ((peoples?.items?.length ?? 0) === 0)
                    resetLocations(FilterOption.USER);
                }}
                autoClearSearchValue={false}
                onSearch={(search) => {
                  if (timeout) clearTimeout(timeout);
                  timeout = setTimeout(() => {
                    if (mapType == "PAGE") return;
                    if (search && search !== "") {
                      let matchedProfiles = (
                        location_profiles?.admin?.liveuser?.profile ?? []
                      ).filter((e: any) => {
                        return (
                          e.name.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1
                        );
                      });
                      getFilterLocations(
                        FilterOption.USER,
                        search,
                        0,
                        false,
                        matchedProfiles
                      );
                      setLocations(FilterOption.USER, {
                        pagination: false,
                      });
                    } else resetLocations(FilterOption.USER);
                  }, 500);
                }}
                filterOption={(input: any, option: any) => {
                  if (mapType == "HOME") return true;
                  else {
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) !== -1
                    );
                  }
                }}
                onPopupScroll={(e: any) => {
                  e.persist();
                  let target = e.target;
                  if (
                    target.scrollTop + target.offsetHeight ===
                    target.scrollHeight
                  ) {
                    if (peoples.pagination) {
                      getFilterLocations(
                        FilterOption.USER,
                        undefined,
                        peoples.page + 1
                      );
                    }
                  }
                }}
              >
                {peoples &&
                  peoples.items.map((people, idx) => (
                    <Option value={people.id} key={idx}>
                      {people.name}
                    </Option>
                  ))}
              </Select>

              <hr />
              <Row
                className="d-flex"
                style={{ marginTop: dropdownVisible ? 150 : 20 }}
              >
                <Col span={12} className="pr-2">
                  <Button
                    className="beam-btn green-btn cover w-full"
                    onClick={() => {
                      onAll(FilterOption.USER);
                    }}
                    disabled={!tempSelectedPlaces}
                  >
                    Apply

                  </Button>
                </Col>
                <Col span={12} className="pl-2">
                  <Button
                    className="beam-btn w-full"
                    onClick={() => {
                      onGroup();
                    }}
                  >
                    Group
                  </Button>
                </Col>
              </Row>
            </Panel>
          </Collapse>

          <br />
        </React.Fragment>
      )}

      {selectedFilter === FilterOption.GPS && (
        <React.Fragment>
          <Collapse defaultActiveKey={["1"]} bordered={false}>
            <Panel
              header={
                <Row>
                  <Col span={24}>
                    <p className="mb-1" style={{ color: "#000000" }}>
                      GPS
                    </p>
                  </Col>
                </Row>
              }
              key="1"
            >
              <Select
                mode="multiple"
                placeholder="Please select peoples"
                allowClear={true}
                dropdownStyle={{ height: 150 }}
                onDropdownVisibleChange={(visible) => {
                  if (visible) {
                    setDropdownVisible(true);
                  } else {
                    setTimeout(() => {
                      setDropdownVisible(false);
                    }, 300);
                  }
                }}
                onChange={(values: string[]) => {
                  let tempPlaces: object[] = gpss.items.filter((e) => {
                    return values.indexOf(e.id) !== -1;
                  });
                  tempPlaces = [...selected_places.items, ...tempPlaces];
                  tempPlaces = tempPlaces.filter(
                    (value: any, index, self) =>
                      index === self.findIndex((t: any) => t.id === value.id) &&
                      (values.indexOf(value.id) !== -1 ||
                        value.objectType !== FilterOption.GPS)
                  );

                  setTempSelectedPlaces(tempPlaces);
                  let filteredPeoples = tempPlaces.filter((e: any) => {
                    return e.objectType === FilterOption.GPS;
                  });

                  setSelectedGpsIds(
                    filteredPeoples.map((e: any) => {
                      return e.id || "";
                    })
                  );
                }}
                value={selectedGpsIds}
                loading={gpss.searching}
                maxTagCount={0}
                style={{ width: "100%" }}
                listHeight={150}
                onFocus={() => {
                  if ((gpss?.items?.length ?? 0) === 0)
                    resetLocations(FilterOption.GPS);
                }}
                autoClearSearchValue={false}
                onSearch={(search) => {
                  if (timeout) clearTimeout(timeout);
                  timeout = setTimeout(() => {
                    if (search && search !== "") {
                      let matchedProfiles = (
                        location_profiles?.admin?.liveuser?.profile ?? []
                      ).filter((e: any) => {
                        return (
                          e.name.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1
                        );
                      });
                      getFilterLocations(
                        FilterOption.GPS,
                        search,
                        0,
                        false,
                        matchedProfiles
                      );
                      setLocations(FilterOption.GPS, {
                        pagination: false,
                      });
                    } else resetLocations(FilterOption.GPS);
                  }, 500);
                }}
                filterOption={(input: any, option: any) => {
                  if (mapType == "HOME") return true;
                  else {
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) !== -1
                    );
                  }
                }}
                onPopupScroll={(e: any) => {
                  e.persist();
                  let target = e.target;
                  if (
                    target.scrollTop + target.offsetHeight ===
                    target.scrollHeight
                  ) {

                    if (gpss.pagination) {
                      getFilterLocations(
                        FilterOption.GPS,
                        undefined,
                        gpss.page + 1
                      );
                    }
                  }
                }}
              >
                {gpss &&
                  gpss.items.map((people, idx) => (
                    <Option value={people.id} key={idx}>
                      {people.beamId}
                    </Option>
                  ))}
              </Select>

              <hr />
              <Row
                className="d-flex"
                style={{ marginTop: dropdownVisible ? 150 : 20 }}
              >
                <Col span={12} className="pr-2">
                  <Button
                    className="beam-btn green-btn cover w-full"
                    onClick={() => {
                      onAll(FilterOption.GPS);
                    }}
                    disabled={!tempSelectedPlaces}
                  >
                    Apply

                  </Button>
                </Col>
                <Col span={12} className="pl-2">
                  <Button
                    className="beam-btn w-full"
                    onClick={() => {
                      onGroup();
                    }}
                  >
                    Group
                  </Button>
                </Col>
              </Row>
            </Panel>
          </Collapse>

          <br />
        </React.Fragment>
      )}

      {selectedFilter === FilterOption.EVENT && (
        <React.Fragment>
          <Collapse defaultActiveKey={["1"]} bordered={false}>
            <Panel
              header={
                <Row>
                  <Col span={24}>
                    <p className="mb-1" style={{ color: "#000000" }}>
                      Events
                    </p>
                  </Col>
                </Row>
              }
              key="1"
            >
              <Select
                mode="multiple"
                placeholder="Please select events"
                allowClear={true}
                dropdownStyle={{ height: 150 }}
                onDropdownVisibleChange={(visible) => {
                  if (visible) {
                    setDropdownVisible(true);
                  } else {
                    setTimeout(() => {
                      setDropdownVisible(false);
                    }, 300);
                  }
                }}
                onChange={(values: string[]) => {
                  let tempPlaces: object[] = events.items.filter((e) => {
                    return values.indexOf(e.id) !== -1;
                  });
                  tempPlaces = [...selected_places.items, ...tempPlaces];
                  tempPlaces = tempPlaces.filter(
                    (value: any, index, self) =>
                      index === self.findIndex((t: any) => t.id === value.id) &&
                      (values.indexOf(value.id) !== -1 ||
                        value.objectType !== FilterOption.EVENT)
                  );
                  setTempSelectedPlaces(tempPlaces);

                  let filteredPeoples = tempPlaces.filter((e: any) => {
                    return e.objectType === FilterOption.EVENT;
                  });

                  setSelectedEventIds(
                    filteredPeoples.map((e: any) => {
                      return e.id || "";
                    })
                  );
                }}
                value={selectedEventIds}
                loading={events.searching}
                maxTagCount={0}
                style={{ width: "100%" }}
                listHeight={150}
                onFocus={() => {
                  if ((events?.items?.length ?? 0) === 0)
                    resetLocations(FilterOption.EVENT);
                }}
                autoClearSearchValue={false}
                onSearch={(search) => {
                  if (timeout) clearTimeout(timeout);
                  timeout = setTimeout(() => {
                    if (search && search !== "") {
                      let matchedProfiles = (
                        location_profiles?.admin?.liveuser?.profile ?? []
                      ).filter((e: any) => {
                        return (
                          e.name.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1
                        );
                      });
                      getFilterLocations(
                        FilterOption.EVENT,
                        search,
                        0,
                        false,
                        matchedProfiles
                      );
                      setLocations(FilterOption.EVENT, {
                        pagination: false,
                      });
                    } else resetLocations(FilterOption.EVENT);
                  }, 500);
                }}
                filterOption={(input: any, option: any) => {
                  if (mapType == "HOME") return true;
                  else {
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) !== -1
                    );
                  }
                }}
                onPopupScroll={(e: any) => {
                  e.persist();
                  let target = e.target;
                  if (
                    target.scrollTop + target.offsetHeight ===
                    target.scrollHeight
                  ) {
                    if (events.pagination) {
                      getFilterLocations(
                        FilterOption.EVENT,
                        undefined,
                        events.page + 1
                      );
                    }
                  }
                }}
              >
                {events &&
                  events.items.map((people, idx) => (
                    <Option value={people.id} key={idx}>
                      {people.name}
                    </Option>
                  ))}
              </Select>

              <hr />
              <Row
                className="d-flex"
                style={{ marginTop: dropdownVisible ? 150 : 20 }}
              >
                <Col span={12} className="pr-2">
                  <Button
                    className="beam-btn green-btn cover w-full"
                    onClick={() => {
                      onAll(FilterOption.EVENT);
                    }}
                    disabled={!tempSelectedPlaces}
                  >
                    Apply
                  </Button>
                </Col>
                <Col span={12} className="pl-2">
                  <Button
                    className="beam-btn w-full"
                    onClick={() => {
                      onGroup();
                    }}
                  >
                    Group
                  </Button>
                </Col>
              </Row>
            </Panel>
          </Collapse>

          <br />
        </React.Fragment>
      )}

      {selectedFilter === FilterOption.PLACE && (
        <React.Fragment>
          <Collapse defaultActiveKey={["1"]} bordered={false}>
            <Panel
              header={
                <Row>
                  <Col span={24}>
                    <p className="mb-1" style={{ color: "#000000" }}>
                      Place
                    </p>
                  </Col>
                </Row>
              }
              key="1"
            >
              <Select
                mode="multiple"
                placeholder="Please select places"
                allowClear={true}
                dropdownStyle={{ height: 150 }}
                onDropdownVisibleChange={(visible) => {
                  if (visible) {
                    setDropdownVisible(true);
                  } else {
                    setTimeout(() => {
                      setDropdownVisible(false);
                    }, 300);
                  }
                }}
                onChange={(values) => {
                  let tempPlaces = places.items.filter((e) => {
                    return values.indexOf(e.id) !== -1;
                  });
                  tempPlaces = [...selected_places.items, ...tempPlaces];
                  tempPlaces = tempPlaces.filter(
                    (value, index, self) =>
                      index === self.findIndex((t) => t.id === value.id) &&
                      (values.indexOf(value.id) !== -1 ||
                        value.objectType !== FilterOption.PLACE)
                  );
                  setTempSelectedPlaces(tempPlaces);

                  let filteredPeoples = tempPlaces.filter((e: any) => {
                    return e.objectType === FilterOption.PLACE;
                  });

                  setSelectedPlacesIds(
                    filteredPeoples.map((e: any) => {
                      return e.id || "";
                    })
                  );
                }}
                value={selectedPlacesIds}
                loading={places.searching}
                maxTagCount={0}
                style={{ width: "100%" }}
                listHeight={150}
                onFocus={() => {
                  if ((places?.items?.length ?? 0) === 0)
                    resetLocations(FilterOption.PLACE);
                }}
                autoClearSearchValue={false}
                onSearch={(search) => {
                  if (timeout) clearTimeout(timeout);
                  timeout = setTimeout(() => {
                    if (mapType == "PAGE") return;
                    if (search && search !== "") {
                      let matchedProfiles = (
                        location_profiles?.admin?.clbs?.profile ?? []
                      ).filter((e: any) => {
                        return (
                          e.name.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1
                        );
                      });
                      console.log(matchedProfiles);
                      getFilterLocations(
                        FilterOption.PLACE,
                        search,
                        0,
                        false,
                        matchedProfiles
                      );
                      setLocations(FilterOption.PLACE, {
                        pagination: false,
                      });
                    } else resetLocations(FilterOption.PLACE);
                  }, 500);
                }}
                filterOption={(input: any, option: any) => {
                  if (mapType == "HOME") return true;
                  else {
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) !== -1
                    );
                  }
                }}
                onPopupScroll={(e: any) => {
                  e.persist();
                  let target = e.target;
                  if (
                    target.scrollTop + target.offsetHeight ===
                    target.scrollHeight
                  ) {
                    if (places.pagination) {
                      getFilterLocations(
                        FilterOption.PLACE,
                        undefined,
                        places.page + 1
                      );
                    }
                  }
                }}
              >
                {places &&
                  places.items.map((place, idx) => (
                    <Option value={place.id} key={idx}>
                      {place.name}
                    </Option>
                  ))}
              </Select>

              <hr />
              <Row
                className="d-flex"
                style={{ marginTop: dropdownVisible ? 150 : 20 }}
              >
                <Col span={12} className="pr-2">
                  <Button
                    className="beam-btn green-btn cover w-full"
                    onClick={() => {
                      onAll(FilterOption.PLACE);
                    }}
                    disabled={!tempSelectedPlaces}
                  >
                    Apply

                  </Button>
                </Col>
                <Col span={12} className="pl-2">
                  <Button
                    className="beam-btn w-full"
                    onClick={() => {
                      onGroup();
                    }}
                  >
                    Group
                  </Button>
                </Col>
              </Row>
            </Panel>
          </Collapse>

          <br />
        </React.Fragment>
      )}

      {selectedFilter === FilterOption.ASSET && (
        <React.Fragment>
          <Collapse defaultActiveKey={["1"]} bordered={false}>
            <Panel
              header={
                <Row>
                  <Col span={24}>
                    <p className="mb-1" style={{ color: "#000000" }}>
                      Assets
                    </p>
                  </Col>
                </Row>
              }
              key="1"
            >
              <Select
                mode="multiple"
                placeholder="Please select assets"
                allowClear={true}
                onDropdownVisibleChange={(visible) => {
                  if (visible) {
                    setDropdownVisible(true);
                  } else {
                    setTimeout(() => {
                      setDropdownVisible(false);
                    }, 300);
                  }
                }}
                dropdownStyle={{ height: 150 }}
                onChange={(values) => {
                  let tempPlaces: object[] = assets?.items?.filter((e) => {
                    return values.indexOf(`${e.id}`) !== -1;
                  });
                  tempPlaces = [...selected_places.items, ...tempPlaces];
                  tempPlaces = tempPlaces.filter(
                    (value: any, index, self) =>
                      index === self.findIndex((t: any) => t.id === value.id) &&
                      (values.indexOf(`${value.id}`) !== -1 ||
                        value.objectType !== FilterOption.ASSET)
                  );
                  setTempSelectedPlaces(tempPlaces);

                  let filteredPeoples = tempPlaces.filter((e: any) => {
                    return e.objectType === FilterOption.ASSET;
                  });

                  setSelectedAssetsIds(
                    filteredPeoples.map((e: any) => {
                      return e.id || "";
                    })
                  );
                }}
                value={selectedAssetsIds}
                loading={assets?.searching}
                maxTagCount={0}
                style={{ width: "100%" }}
                listHeight={150}
                onFocus={() => {
                  if ((assets?.items?.length ?? 0) === 0)
                    resetLocations(FilterOption.ASSET);
                }}
                autoClearSearchValue={false}
                onSearch={(search) => {
                  if (timeout) clearTimeout(timeout);
                  timeout = setTimeout(() => {
                    if (mapType == "PAGE") return;
                    if (search && search !== "") {
                      let matchedProfiles = (
                        location_profiles?.admin?.asset?.profile ?? []
                      ).filter((e: any) => {
                        return (
                          e.name.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1
                        );
                      });
                      getFilterLocations(
                        FilterOption.ASSET,
                        search,
                        0,
                        false,
                        matchedProfiles
                      );
                      setLocations(FilterOption.ASSET, {
                        pagination: false,
                      });
                    } else resetLocations(FilterOption.ASSET);
                  }, 500);
                }}
                filterOption={(input: any, option: any) => {
                  if (mapType == "HOME") return true;
                  else {
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) !== -1
                    );
                  }
                }}
                onPopupScroll={(e: any) => {
                  e.persist();
                  let target = e.target;
                  if (
                    target.scrollTop + target.offsetHeight ===
                    target.scrollHeight
                  ) {
                    if (assets.pagination) {
                      getFilterLocations(
                        FilterOption.ASSET,
                        undefined,
                        assets?.page + 1
                      );
                    }
                  }
                }}
              >
                {assets &&
                  assets.items?.map((asset, idx) => (
                    <Option value={asset.id} key={idx}>
                      {asset.name}
                    </Option>
                  ))}
              </Select>

              <hr />
              <Row
                className="d-flex"
                style={{ marginTop: dropdownVisible ? 150 : 20 }}
              >
                <Col span={12} className="pr-2">
                  <Button
                    className="beam-btn green-btn cover w-full"
                    onClick={() => {
                      onAll(FilterOption.ASSET);
                    }}
                    disabled={!tempSelectedPlaces}
                  >
                    Apply

                  </Button>
                </Col>
                <Col span={12} className="pl-2">
                  <Button
                    className="beam-btn w-full"
                    onClick={() => {
                      onGroup();
                    }}
                  >
                    Group
                  </Button>
                </Col>
              </Row>
            </Panel>
          </Collapse>
          <br />
        </React.Fragment>
      )}

      {mapType === "HOME" && selectedFilter === FilterOption.PAGE && (
        <React.Fragment>
          <Collapse defaultActiveKey={["1"]} bordered={false}>
            <Panel
              header={
                <Row>
                  <Col span={24}>
                    <p className="mb-1" style={{ color: "#000000" }}>
                      Page
                    </p>
                  </Col>
                </Row>
              }
              key="1"
            >
              <Select
                mode="multiple"
                placeholder="Please select pages"
                allowClear={true}
                onDropdownVisibleChange={(visible) => {
                  if (visible) {
                    setDropdownVisible(true);
                  } else {
                    setTimeout(() => {
                      setDropdownVisible(false);
                    }, 300);
                  }
                }}
                dropdownStyle={{ height: 150 }}
                onChange={(values) => {
                  let tempPlaces: object[] = pages.items.filter((e) => {
                    return values.indexOf(`${e.id}`) !== -1;
                  });
                  tempPlaces = [...selected_places.items, ...tempPlaces];
                  tempPlaces = tempPlaces.filter(
                    (value: any, index, self) =>
                      index === self.findIndex((t: any) => t.id === value.id) &&
                      (values.indexOf(`${value.id}`) !== -1 ||
                        value.objectType !== FilterOption.PAGE)
                  );

                  setTempSelectedPlaces(tempPlaces);
                  let filteredPeoples = tempPlaces.filter((e: any) => {
                    return e.objectType === FilterOption.PAGE;
                  });

                  setSelectedPagesIds(
                    filteredPeoples.map((e: any) => {
                      return e.id || "";
                    })
                  );
                }}
                value={selectedPagesIds}
                loading={pages.searching}
                maxTagCount={0}
                style={{ width: "100%" }}
                listHeight={150}
                onFocus={() => {
                  if ((pages?.items?.length ?? 0) === 0)
                    resetLocations(FilterOption.PAGE);
                }}
                autoClearSearchValue={false}
                onSearch={(search) => {
                  if (timeout) clearTimeout(timeout);
                  timeout = setTimeout(() => {
                    if (search && search !== "") {
                      getFilterLocations(FilterOption.PAGE, search, 0, false);
                      setLocations(FilterOption.PAGE, {
                        pagination: false,
                      });
                    } else resetLocations(FilterOption.PAGE);
                  }, 500);
                }}
                filterOption={(input: any, option: any) => {
                  if (mapType == "HOME") return true;
                  else {
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) !== -1
                    );
                  }
                }}
                onPopupScroll={(e: any) => {
                  e.persist();
                  let target = e.target;
                  if (
                    target.scrollTop + target.offsetHeight ===
                    target.scrollHeight
                  ) {
                    if (pages.pagination) {
                      getFilterLocations(
                        FilterOption.PAGE,
                        undefined,
                        pages.page + 1
                      );
                    }
                  }
                }}
              >
                {pages &&
                  pages.items.map((page, idx) => (
                    <Option value={page.id} key={idx}>
                      {page.name}
                    </Option>
                  ))}
              </Select>

              <hr />
              <Row
                className="d-flex"
                style={{ marginTop: dropdownVisible ? 150 : 20 }}
              >
                <Col span={12} className="pr-2">
                  <Button
                    className="beam-btn green-btn cover w-full"
                    onClick={() => {
                      onAll(FilterOption.PAGE);
                    }}
                    disabled={!tempSelectedPlaces}
                  >
                    Apply
                  </Button>
                </Col>
                <Col span={12} className="pl-2">
                  <Button className="beam-btn w-full">Group</Button>
                </Col>
              </Row>
            </Panel>
          </Collapse>

          <br />
        </React.Fragment>
      )}

      {selectedFilter === FilterOption.MEDIA && (
        <Collapse defaultActiveKey={["1"]} bordered={false}>
          <Panel
            header={
              <Row>
                <Col span={24}>
                  <p className="mb-1" style={{ color: "#000000" }}>
                    Media
                  </p>
                </Col>
              </Row>
            }
            key="1"
          >
            <Select
              mode="multiple"
              placeholder="Please select media"
              allowClear={true}
              dropdownStyle={{ height: 150 }}
              onChange={(values) => {
                let tempPlaces: object[] = medias?.items
                  ?.filter((e) => {
                    return values.indexOf(`${e.id}`) !== -1;
                  })
                  .map((media: any) => {
                    return {
                      ...media,
                      ...Object.assign(
                        {},
                        media?.data?.info
                          ? {
                              ...media?.data,
                              location: {
                                coordinates: [
                                  media?.data?.info?.location?.coordinates
                                    ?.long,
                                  media?.data?.info?.location?.coordinates?.lat,
                                ],
                              },
                            }
                          : {}
                      ),
                    };
                  });

                tempPlaces = [...selected_places.items, ...tempPlaces];
                tempPlaces = tempPlaces.filter(
                  (value: any, index, self) =>
                    index === self.findIndex((t: any) => t.id === value.id) &&
                    (values.indexOf(`${value.id}`) !== -1 ||
                      (value.objectType !== FilterOption.MEDIA &&
                        value.objectType !== "medium"))
                );

                setTempSelectedPlaces(tempPlaces);
                let filteredPeoples = tempPlaces.filter((e: any) => {
                  return (
                    e.objectType === FilterOption.MEDIA ||
                    e.objectType === "medium"
                  );
                });

                setSelectedMediasIds(
                  filteredPeoples.map((e: any) => {
                    return e.id || "";
                  })
                );
              }}
              value={selectedMediaIds}
              loading={medias?.searching}
              maxTagCount={0}
              style={{ width: "100%" }}
              listHeight={150}
              onFocus={() => {
                if ((medias?.items?.length ?? 0) === 0)
                  resetLocations(FilterOption.MEDIA);
              }}
              onDropdownVisibleChange={(visible) => {
                if (visible) {
                  setDropdownVisible(true);
                } else {
                  setTimeout(() => {
                    setDropdownVisible(false);
                  }, 300);
                }
              }}
              autoClearSearchValue={false}
              onSearch={(search) => {
                if (timeout) clearTimeout(timeout);
                timeout = setTimeout(() => {
                  if (mapType == "PAGE") return;
                  if (search && search !== "") {
                    getFilterLocations(FilterOption.MEDIA, search, 0, false);
                    setLocations(FilterOption.MEDIA, {
                      pagination: false,
                    });
                  } else resetLocations(FilterOption.MEDIA);
                }, 500);
              }}
              filterOption={(input: any, option: any) => {
                if (mapType == "HOME") return true;
                else {
                  return (
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) !== -1
                  );
                }
              }}
              onPopupScroll={(e: any) => {
                e.persist();
                let target = e.target;
                if (
                  target.scrollTop + target.offsetHeight ===
                  target.scrollHeight
                ) {
                  if (medias?.pagination) {
                    getFilterLocations(
                      FilterOption.MEDIA,
                      undefined,
                      medias?.page + 1
                    );
                  }
                }
              }}
            >
              {medias &&
                medias?.items?.map((media, idx) => (
                  <Option value={media.id} key={idx}>
                    {media.name}
                  </Option>
                ))}
            </Select>

            <hr />
            <Row
              className="d-flex"
              style={{ marginTop: dropdownVisible ? 150 : 20 }}
            >
              <Col span={12} className="pr-2">
                <Button
                  className="beam-btn green-btn cover w-full"
                  onClick={() => {
                    onAll(FilterOption.MEDIA);
                  }}
                  disabled={!tempSelectedPlaces}
                >
                  Apply

                </Button>
              </Col>
              <Col span={12} className="pl-2">
                <Button className="beam-btn w-full">Group</Button>
              </Col>
            </Row>
          </Panel>
        </Collapse>
      )}
    </div>
  );
};

export default FilterPop;
